// extracted by mini-css-extract-plugin
export default {"inputErrorMessage":"axnui-input-error-message__input-error-message__OcYKR","specific":"axnui-input-error-message__specific__N614H"};